import React, { useMemo } from 'react'
import { MainNavigation as BaseNavigation } from '@campaignhub/suit-theme'

import useBusinessUnits from '@hooks/useBusinessUnits'
import useCurrentUser from '@hooks/useCurrentUser'
import useMainNavigation from '@hooks/useMainNavigation'

import systemBrandPayload from '@components/systemBrands/default'
import generateMainNavigationItems from '@sections/Admin/utils/generateMainNavigationItems'

interface MainNavigationProps {
  minimized: boolean,
  nestedNavigation: React.ReactNode,
  width: number,
}

const MainNavigation = (props: MainNavigationProps) => {
  const { minimized, nestedNavigation, width } = props

  const { filteredBusinessUnits } = useBusinessUnits({ filters: { filterActive: true } })

  const { isAdmin, userTypeName } = useCurrentUser()

  const navigationItems = useMemo(
    () => generateMainNavigationItems({ businessUnits: filteredBusinessUnits, isAdmin, userTypeName }),
    [filteredBusinessUnits.length, isAdmin, userTypeName],
  )

  const { callbacks: { toggleNavigation }, showNavigation } = useMainNavigation()

  return (
    <BaseNavigation
      callbacks={{ toggleSidebar: toggleNavigation }}
      minimized={minimized}
      navigationItems={navigationItems}
      nestedNavigation={nestedNavigation}
      nestedNavigationWidth={240}
      showNavigation={showNavigation}
      systemBrandPayload={systemBrandPayload}
      width={width}
    />
  )
}

export default MainNavigation
